import { TourismEventSlots, TourismEventWithSlots } from '@/bag/bag-transport-term/bag-transport-term.model';
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Result } from '@/reservation/reservation.model';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class TourismEventTransportTermSlotsStore {
	slotMap = new Map<string, TourismEventSlots>();

	private readonly httpClient = inject(HttpClient);

	//try matching given toursimEvents with the ones returned from bag and receive empty promise when finished
	populateSlotMapWithMatchesToTourismEvents(
		dateFrom: string,
		dateTo: string,
	): Observable<Result<TourismEventWithSlots>> {
		const url = `${environment.apiUrl}/transport/transport_term_tourism_event/?transport_term_exists=true&limit=9999&departure_time_after=${dateFrom}&departure_time_before=${dateTo}`;

		return this.httpClient.get<Result<TourismEventWithSlots>>(url);
	}
}
